import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupService } from "../../../services/signup.service";
import { BaseComponent } from "../../base/base.component";
import { RegisterVM } from "../../../models";

@Component({
    selector: 'signup-step4',
    templateUrl: './step4.component.html'
})
export class Step4Component extends BaseComponent {
    email: string;
    firstname: string;
    lastname: string;
    resendToken: string;

    constructor(private signupService: SignupService,
        private route: ActivatedRoute,
        private router: Router) {
        super(route);
        this.email = this.signupService.model.email;
        this.firstname = this.signupService.model.firstname;
        this.lastname = this.signupService.model.lastname;
        this.signupService.model = new RegisterVM();
    }

    ngOnInit(): void {
        if (this.signupService.resendToken != null) {
            this.resendToken = this.signupService.resendToken;
        }
        else {
            this.router.navigateByUrl('/');
        }
    }

    resend() {
        this.signupService.resendVerifyAccount(this.resendToken)
            .subscribe(
                r => {
                    if (r) {
                        this.showDialog("Another email with a verification link has been sent to your inbox. Please check your spam folder.", false);
                    }
                    else {
                        this.showDialog("Cannot request a resend, please check your account status", false);
                    }
                },
                e => this.showDialog(e, true),
                () => { }
            );

        return false;
    }

}